import { Injectable } from '@angular/core';

import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
/**
 * RXJS
 * BehaviorSubject so we can create variables we can subscribe to 
 */
import { BehaviorSubject } from 'rxjs';

/**
 * ====== JS LIBRARIES=====
 */
import { merge as lodashMerge } from 'lodash';


/**
 * SERVICES
 */
import { StorageService } from './storage.service'


/**
 * TYPES TO USE
 */
type DynamicObj = {[key: string | number ] : string | number | any }


@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  public languague = new BehaviorSubject<any>( 
    { locale: 'en', title: 'English', timestamp : '' }
  ); //defaults subscribable

  public direction = new BehaviorSubject<string>( 'ltr' ); //subscribable with default

  public translations: any = {};
  public languages : any = [
    
    { locale: 'ar', title: 'العربية' , direction: 'rtl' }, //arabic
    { locale: 'bg', title: 'български' }, //bulgarian
    { locale: 'cs', title: 'Czech' }, //czech
    { locale: 'de', title: 'Deutsch' }, //german
    { locale: 'de_BE', title: 'Deutsch (BE)' }, //german belgium
    { locale: 'de_CH', title: 'Deutsch (CH)' }, //german swiss
    { locale: 'el', title: 'Ελληνική' }, //greek 
    { locale: 'en', title: 'English' }, //english
    { locale: 'en_US', title: 'English (US)' }, //english us
    { locale: 'es', title: 'Español' }, //spanish
    { locale: 'es_MX', title: 'Español (MX)' }, //spanish mexican
    { locale: 'fr_BE', title: 'Française (BE)' }, //french belgium
    { locale: 'fr_CH', title: 'Française (CH)' },//french swiss
    { locale: 'hi', title: 'हिन्दी' }, //hindi
    { locale: 'it' , title: 'Italiano' }, //italian
    { locale: 'lv', title: 'Latviešu' }, //latvian
    { locale: 'ms', title: 'Melayu' }, //malay
    { locale: 'nl_BE', title: 'Nederlands (BE)' },//dutch belgium
    { locale: 'pl', title: 'Polski' }, //polish
    { locale: 'pt' , title: 'Português' }, //portuguese
    { locale: 'ru', title: 'Pусский' }, //russian
    { locale: 'ta', title: 'தமிழ்' }, //tamil
    { locale: 'th', title: 'ไทย' }, //thai
    { locale: 'tl', title: 'Filipino' },  //filipino
    { locale: 'tr', title: 'Türkçe' }, //turkish
    { locale: 'ja', title: '日本人' }, //japanese
    { locale: 'zh', title: '中文' }, //chinese


  ];
  public locale: string = 'en';
  public langLoaded: boolean = false;

  
  public unsetTerms: DynamicObj = {};

  public coreDictionary: DynamicObj = {};

  /**
   * CONSTRUCTOR
   * @param storage 
   * @param sanitizer 
   */
  constructor(
    private storage: StorageService,
    protected sanitizer: DomSanitizer
  ) { 
    this.setup();
  }

  setup(){
    // console.log("🚀 ~ file: translate.service.ts:79 ~ TranslateService ~ setup ~ setup:", "setup")
    this.setCoreDictionaries();
    
    this.updateLang( 'en' );

    this.storage.get( 'unsetTerms' ).then( ( data )=>{
      if( data ){
        this.unsetTerms = data;
      }
    });

    this.getAndSetLang();
  }

  getAndSetLang(){
    let myClass =this;
    var promise = new Promise(function(resolve, reject){
      myClass.storage.get( 'locale' ).then( ( data )=>{
        if( data ){
          myClass.updateLang( data ).then(()=>{
            resolve( true);
          });
        }else{
          myClass.updateLang( 'en' ).then(()=>{
            resolve( true);
          });
        }
      });
    });
    return promise;
  }

  updateLang( locale : string ){
    // console.log("🚀 ~ file: translate.service.ts:112 ~ TranslateService ~ updateLang ~ updateLang:", "updateLang")
    //update observables
    //load languague from storage
    let myClass = this;

    this.langLoaded = true;
    
    var promise = new Promise(function(resolve, reject){
      myClass.storage.get( 'lang_' + locale ).then( data => {
      // console.log("🚀 ~ file: translate.service.ts:121 ~ TranslateService ~ myClass.storage.get ~ data:", data)

        /*data = Object.assign( myClass.coreDictionary[ locale ], data );*/

        data = lodashMerge( myClass.coreDictionary[ locale ] , data )

        // console.log("TranslateService -> updateLang -> myClass.coreDictionary[ locale ], data ", myClass.coreDictionary[ locale ], data )

        myClass.locale = locale;
        myClass.translations = data.translations ;



        // console.log("🚀 ~ file: translate.service.ts:137 ~ TranslateService ~ myClass.storage.get ~ data.direction:", data.direction)


        myClass.direction.next( data.direction );
        myClass.languague.next( { locale : locale , title : data.title, timestamp: data.timestamp } );
        myClass.storage.set( 'locale' , locale );


        resolve( data );
      })
    });

    return promise;

  }//updateLang()

  translate( value: string, ...args: any[]): any {
     //console.log("TranslateService -> translate -> value", value);
    

    if( ! this.langLoaded ){
      // console.log("🚀 ~ file: translate.service.ts:142 ~ TranslateService ~ translate ~ this.langLoaded:", this.langLoaded)
      //load lang first
      this.updateLang( this.locale );
    }
    // console.log("🚀 ~ file: translate.service.ts:145 ~ TranslateService ~ translate ~ this.locale :", this.locale )
    
    //then get this lang pack
    var result = this.findProp ( 
      this.translations, 
      value , 
      null 
    );
      // console.log("🚀 ~ file: translate.service.ts:151 ~ TranslateService ~ translate ~ this.translations:", this.translations)
      // console.log("🚀 ~ file: translate.service.ts:154 ~ TranslateService ~ translate ~ result:", result)

    var sanitize = null;
    if( args[0] ){
        if( args[0][1]){
          sanitize = args[0][1];
          // console.log("TranslateService -> translate -> args",   args[0][1] )
        }
        
    }
  

    // console.log("TranslateService -> translate -> value, this.locale, this.translations , result ", value,  this.locale,  this.translations , result );
    if( result == null ){

      this.unsetTerms[ value ] = 1;
      this.storage.set( 'unsetTerms' , this.unsetTerms );

      return '[' + value +']' ;
    }else{
      if( sanitize == 'safeHtml'){
        result = this.sanitizer.bypassSecurityTrustHtml( this.nl2br( result , false ) );
      }
      return result;
    }

  }//end translate fn

  /**
   * 
   * @param obj object to navigate
   * @param prop the prop we are looking for
   * @param defval pass in null, this is for recursion
   */
  findProp(obj : any , prop : string  , defval : string | null ){
    if (typeof defval == 'undefined') defval = null;
    let propArray = prop.split('.');
    for (var i = 0; i < propArray.length; i++) {
        if(typeof obj[propArray[i]] == 'undefined' ){
           // console.log( obj , prop, prop[i] );
            return propArray[ propArray.length - 1];
        }
        obj = obj[propArray[i]];
    }
    return obj;
  }



  setCoreDictionaries(){

    this.languages.forEach( (element: any)  => { //set up core dictionaries
      let direction = 'ltr';
      if( element?.direction == 'rtl' ){  //if direction is right to left
        direction = 'rtl';
      }
      this.coreDictionary[ element.locale ] = { //set up core dictionary
        timestamp: '2000-01-01 01:00:00',
        title: element.title ,
        locale: element.locale ,
        direction: direction,
        translations: {
          "global" : {
            "app" : {
            }
          }
        },
      };
    });

    // this.coreDictionary[ 'ar' ] = //arabic
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'العربية',
    //   locale: 'ar',
    //   direction: 'rtl',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };
 
    // this.coreDictionary[ 'hi' ] = //hindi
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'हिन्दी',
    //   locale: 'hi',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };
    

    // this.coreDictionary[ 'ta' ] = //tamil
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'தமிழ்',
    //   locale: 'ta',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };
    // this.coreDictionary[ 'ms' ] = //malay
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'Melayu',
    //   locale: 'ms',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };
    
    // this.coreDictionary[ 'cs' ] =
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'Czech',
    //   locale: 'cs',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };
    
    
    // this.coreDictionary[ 'de'] =
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'Deutsch',
    //   locale: 'de',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };

    // this.coreDictionary[ 'de_BE'] =
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'Deutsch (BE)',
    //   locale: 'de_BE',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };

  

    // this.coreDictionary[ 'de_CH'] =
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'Deutsch (CH)',
    //   locale: 'de_CH',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };


    // this.coreDictionary[ 'en'] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'English',
    //     locale: 'en',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //           "Date" : "Date",
    //           "Greeting" : "Hello world",
    //           "Yes" : "Yes",
    //           "No" : "No",
    //           "Cancel" : "Cancel",
    //           "Login" : "Log in",
    //           "Log in" : "Log in",
    //           "Log out" : "Log out",
    //           "LogOutConfirm" : "Are you sure you wish to log out?",
    //           "Email" : "Email",
    //           "Fail" : "Fail",
    //           "Pass" : "Pass",
    //           "Password" : "Password",
    //           "Home" : "Home",
    //           "Please wait" : "Please wait",
    //           "Please wait..." : "Please wait...!",
    //           "Settings" : "Settings",
    //           "Syncing" : "Syncing",
    //           "New App Version Available" : "New App Version Available",
    //           "AppVersionConfirm" : "An updated version of the app is available, do you wish to download it?",

    //           "If your email address is registered with us, we have sent you a link to reset your password" : "If your email address is registered with us, we have sent you a link to reset your password",
    //           "Lost Password" : "Lost Password" ,
    //           "Get Password" : "Get Password", 

    //           "Begin Check" : "Begin Check",
    //           "Estimated distance" : "Distance",
    //           "Requires an internet connection" : "Requires an internet connection",
    //           "PDF Report" : "PDF Report",
    //           "Error retrieving data" : "Error retrieving data",
    //           "Please correct validation issues before completing the check" : "Please correct validation issues before completing the check",

    //         },
            
    //       }
    //     }
    //   }
    // ;


    // this.coreDictionary[ 'en_US'] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'English - US',
    //     locale: 'en_US',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'es' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'Español',
    //     locale: 'es',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'es_MX' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'Español (MX)',
    //     locale: 'es_MX',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'fr_BE'] =
    // {
    //   timestamp: '2000-01-01 01:00:00',
    //   title: 'Française (BE)',
    //   locale: 'fr_BE',
    //   direction: 'ltr',
    //   translations: {
    //     "global" : {
    //       "app" : {
    //       }
    //     }
    //   },
    // };

    

    //   this.coreDictionary[ 'fr_CH' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'Française (CH)',
    //     locale: 'fr_CH',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

      

    //   this.coreDictionary[ 'nl_BE' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'Nederlands (BE)',
    //     locale: 'nl_BE',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'pl' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'Polski',
    //     locale: 'pl',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'tr' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: 'Türkçe',
    //     locale: 'tr',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'ja' ] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: '日本人',
    //     locale: 'ja',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

    //   this.coreDictionary[ 'zh'] =
    //   {
    //     timestamp: '2000-01-01 01:00:00',
    //     title: '中文',
    //     locale: 'zh',
    //     direction: 'ltr',
    //     translations: {
    //       "global" : {
    //         "app" : {
    //         }
    //       }
    //     },
    //   };

  }

  nl2br (str : string, is_xhtml : boolean ) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }
}
